import React from "react";
import { CheckboxGrid } from "./FilterShared";

const VISA_STATUS_OPTIONS = [
  { value: 5, title: "US Resident/Citizen" },
  { value: 9, title: "EAD" },
  { value: 8, title: "H1-B" },
];

export const VisaStatusPanel = ({ values = {}, set }) => {
  const safeSet = set?.("visaStatusId") || (() => {});

  return (
    <div className="qp-filter-panel-body">
      <CheckboxGrid
        value={Array.isArray(values.visaStatusId) ? values.visaStatusId : []}
        onChange={safeSet}
        options={VISA_STATUS_OPTIONS}
      />
    </div>
  );
};
